
export default function createLazyReadOnlyGridXY<T>(
  gridWidth: number,
  gridHeight: number,
  fn: (x: number, y: number) => T
) {
  // const data: GridXY<T | undefined> = createGridXY<T | undefined>(gridWidth, gridHeight, void 0)
  const data : Array<T | undefined> = new Array(gridWidth * gridHeight)
  return function lazyGridReaderFn(x: number, y: number): T {
    if (x>=0 && y >= 0 && x < gridWidth && y < gridHeight) {
      const idx = x + (y * gridWidth)
      let value = data[idx]
      if (value === void 0) {
        value = data[idx] = fn(x, y)
      }
      return value
    }
    return fn(x, y)
  }
}
